/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type BuildingLogActorType =
    (typeof BuildingLogActorType)[keyof typeof BuildingLogActorType];

export const BuildingLogActorType = {
    User: 0,
    System: 1,
} as const;
